import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { APP_NAME, TAGLINE, titleForPath } from './pageTitleLogic.mjs'

// Route→title mapping + titleForPath/pageNameForPath live in
// ./pageTitleLogic.mjs (pure, so Node's test runner can cover the
// longest-match logic without React). This file only wires them to the
// DOM/router.
export { APP_NAME, titleForPath, pageNameForPath } from './pageTitleLogic.mjs'

// Sets the document title from the route. Pages showing a named record (a model,
// a dataset) can override with setDocumentTitle once they know the name.
export function usePageTitle() {
  const { pathname } = useLocation()
  useEffect(() => {
    document.title = titleForPath(pathname)
  }, [pathname])
}

export function setDocumentTitle(contentTitle) {
  document.title = contentTitle ? `${APP_NAME} | ${contentTitle}` : `${APP_NAME} — ${TAGLINE}`
}
